module.exports = __webpack_public_path__ + "img/services-one-3.d1879685.png";